import React, { useState,useEffect } from "react";
import { Modal, Box, Typography, TextField, MenuItem, CircularProgress } from "@mui/material";
import MDButton from "components/MDButton";
import { useAlerta } from "utils/alertas";

export default function AgregarGrupoModal({ open, onClose, onGrupoAgregado, semestres }) {
  const [nombre, setNombre] = useState("");
  const [turno, setTurno] = useState("");
  const [modalidad, setModalidad] = useState("");
  const [dias , setDias]= useState("");
  const [capacidad, setCapacidad] = useState("");
  const [estado, setEstado] = useState(1); // activo por defecto
  const [gestion, setGestion] = useState("");
  const [loading, setLoading] = useState(false);
  const [gestiones, setGestiones] = useState([]);
  const [loadingGestiones, setLoadingGestiones] = useState(false);  
  const [semestre, setSemestre] = useState("");
  const { mostrarAlerta } = useAlerta();

  const token = sessionStorage.getItem("access_token");
  const cargarGestiones = async () => {
    setLoadingGestiones(true);

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/gestiones`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      const data = await res.json();

      const lista = Array.isArray(data.data) ? data.data : data;

      setGestiones(lista || []);
    } catch (error) {
      console.error("Error cargando gestiones:", error);
      setGestiones([]);
    } finally {
      setLoadingGestiones(false);
    }
  };
  const handleSemestreChange = (event) => {
    setSemestre(event.target.value);
  } 
  useEffect(() => {
    if (open) {
      cargarGestiones();
    }
  }, [open]);

  const handleSubmit = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/semestre/grupos`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            nombre,
            turno,
            modalidad,
            gestion,
            dias,
            cupo_maximo: capacidad ? parseInt(capacidad) : null,
            estado,
            semestre_id:semestre,
          }),
        }
      );
      mostrarAlerta("Grupo creado correctamente","success");

      if (!response.ok) {
        const errorData = await response.json();
        mostrarAlerta(errorData.message || "Error al agregar grupo", "error");
        throw new Error(errorData.message || "Error al agregar grupo");
      }

      await response.json();
      if (onGrupoAgregado) onGrupoAgregado(); 
      onClose();

      setNombre("");
      setTurno("");
      setModalidad("");
      setGestion("");
      setDias("");
      setCapacidad("");
      setEstado(1);
    } catch (error) {
      console.error("Error al agregar grupo:", error);
      mostrarAlerta(
          error.message || "Error al agregar grupo",
          "error"
        );
    } finally {
      setLoading(false);
    }
  };


  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <Typography variant="h6" mb={2}>
          Agregar Grupo
        </Typography>

        <TextField
          fullWidth
          label="Nombre del Grupo"
          value={nombre}
          onChange={(e) => setNombre(e.target.value)}
          sx={{ mb: 2 }}
        />
        <TextField
          select
          fullWidth
          label="Turno"
          value={turno}
          onChange={(e) => setTurno(e.target.value)}
          SelectProps={{ native: true }}
          sx={{ mb: 2 }}
        >
          <option value=""></option>
          <option value="Mañana">Mañana</option>
          <option value="Tarde">Tarde</option>
          <option value="Noche">Noche</option>
        </TextField>
        <TextField
          select
          fullWidth
          label="Modalidad"
          value={modalidad}
          onChange={(e) => setModalidad(e.target.value)}
          SelectProps={{ native: true }}
          sx={{ mb: 2 }}
        >
          <option value=""> </option>
          <option value="presencial">Presencial</option>
          <option value="semipresencial">Semi presencial</option>
          <option value="virtual">Virtual</option>
        </TextField>
        <TextField
          select
          fullWidth
          label="Gestión Académica"
          value={gestion}
          onChange={(e) => setGestion(e.target.value)}
          SelectProps={{ native: true }}
          sx={{ mb: 2 }}
        >
          <option value=""></option>

          {gestiones.map((g) => (
            <option key={g.id} value={g.id}>
              {g.nombre}
            </option>
          ))}
        </TextField>
        <TextField
          select
          fullWidth
          label="Semestre/Año"
          value={semestre}
          onChange={handleSemestreChange}
          SelectProps={{ native: true }}
          sx={{ mb: 2 }}
        >
          <option value=""></option>
          {semestres.map((s) => (
            <option key={s.id} value={s.id}>
              {s.nombre} {s.numero}
            </option>
          ))}
        </TextField>
        <TextField
          select
          fullWidth
          label="Dias"
          value={dias}
          onChange={(e) => setDias(e.target.value)}
          SelectProps={{ native: true }}
          sx={{ mb: 2 }}        
        >
          <option value=""></option>
          <option value="lunes_a_viernes">Lunes a Viernes</option>
          <option value="lunes_miercoles_viernes">Lunes, miercoles, viernes</option>
          <option value="martes_jueves"> Martes, jueves</option>
          <option value="sabados">sabado</option>
        </TextField>
        <TextField
          fullWidth
          label="Capacidad"
          type="number"
          value={capacidad}
          onChange={(e) => setCapacidad(e.target.value)}
          sx={{ mb: 2 }}
        />
        <MDButton
          variant="contained"
          color="info"
          fullWidth
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} /> : "Agregar Grupo"}
        </MDButton>
      </Box>
    </Modal>
  );
}
